import Cookies from "js-cookie";

export const getAuthHeader = () => {
  const token = Cookies.get("access_token");

  const headers: Record<string, string> = {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return headers;
};
